<template lang="pug">
.content(:class="isTimeslotLowerThan15Min(timeslot) ? `content-slim` : ``")
  .top-row-holder.flex.justify-between.flex-none
    .top-left-data
      BriqTooltip(:help="bookingNumberTooltip" :position="timeslotIndex === 0 ? `bottom-left`:`top-left`")  
        .booking-customer(data-test-id="booking-customer" :title="bookingProduct.CustomerName") {{ bookingProduct.CustomerName }}
        .time(data-test-id="booking-card-time") {{ bookingProductTime }}
    .top-right-icons.flex.flex-none
      .booking-card-icon
        BriqTooltip(:help="checkedInStatusTooltip" :position="timeslotIndex === 0 ? `bottom-left`:`top-left`")
          BriqIcon(:name="`icon-participant-${checkedInStatusColor}-planboard`")
      .booking-card-icon
        BriqTooltip(:help="paidTooltip" :position="timeslotIndex === 0 ? `bottom-left`:`top-left`")
          BriqIcon(:name="`icon-creditcard-${paidStatusColor}-planboard`" customStyle="margin-top: 5px;")
  .bottom-right-icons.flex.flex-none.justify-end(v-if="isTimeslotGreaterThan15Min(timeslot)" data-test-id="bottom-icons")
    .segment(
      v-if="bookingProduct.SegmentAvatar"
      :style="`background-color: ${bookingProduct.SegmentAvatar.Color}`"
      ) {{ bookingProduct.SegmentAvatar.ShortName }}
    .booking-card-icon(v-if="bookingProduct.MultiActivity" data-test-id="multiactivity-icon")
      BriqTooltip(:help="multiActivityTooltip" position="top-left")
        BriqIcon(name="icon-multiactivity-planboard")
    .booking-card-icon(v-if="bookingProduct.BookingHasNotes" data-test-id="notes-icon")
      BriqTooltip(:help="bookingHasNotesTooltip" position="top-left")
        BriqIcon(name="icon-comment-planboard")
</template>
<script>
import { pipe } from 'ramda'
import { getMinutesFromDuration } from '@/helpers/getTimeFromDuration.js'
import { getTimeslotParts } from '@/vue/planboard/planboard-calendar/planboardCalendarUtil.js'
import { currencyFormatter } from '@/helpers/intlFormatter.js'

export default {
  name: 'BookingCardContent',
  props: {
    bookingProduct: Object,
    bookingProductTime: String,
    timeslot: Object,
    timeslotIndex: Number,
  },
  computed: {
    bookingNumberTooltip() {
      return `Booking number: ${this.bookingProduct.BookingNumber}`
    },
    checkedInStatusTooltip() {
      const notLabel = !this.bookingProduct.BookingCheckedIn ? ' not ' : ''
      return `Visitor(s) has ${notLabel} checked in`
    },
    checkedInStatusColor() {
      return this.bookingProduct.BookingCheckedIn ? 'green' : 'gray'
    },
    paidStatusColor() {
      return this.bookingProduct.BookingFullyPaid ? 'green' : 'gray'
    },
    bookingHasNotesTooltip() {
      return this.bookingProduct.BookingHasNotes ? 'Note present' : ''
    },
    paidTooltip() {
      const formatPrice = currencyFormatter(this.$locale, this.$currency).format
      const amountPaid = formatPrice(this.bookingProduct.BookingAmountPaid)

      if (this.bookingProduct.BookingFullyPaid) return `Booking is fully paid (${amountPaid})`
      if (this.bookingProduct.BookingAmountPaid > 0)
        return `Amount paid for this booking is ${amountPaid}`
      return 'Booking is not paid'
    },
    multiActivityTooltip() {
      return 'Multiple activities'
    },
  },
  methods: {
    isTimeslotGreaterThan15Min(ts) {
      const isGreaterThanOne = n => n > 1
      return pipe(getMinutesFromDuration, getTimeslotParts, isGreaterThanOne)(ts.Duration)
    },
    isTimeslotLowerThan15Min(ts) {
      return getMinutesFromDuration(ts.Duration) < 15
    },
  },
}
</script>

<style scoped lang="stylus">
.content
  margin-top 8px
  margin-left 16px
  width 85%

  .top-row-holder
    width 177px

    .booking-customer
      font-weight 500
      font-size 12px
      line-height 16px
      color #000E28 //black1
      text-overflow ellipsis
      overflow hidden
      width 134px
      white-space nowrap

  .bottom-right-icons
    position absolute
    bottom 6px
    right 17px

    .segment
      background-color #000E28 //black1
      border-radius 3px
      color white
      font-size 12px
      line-height 12px
      height 16px
      width 16px
      text-align center
      line-height 16px
      margin-left 5px

  .time
    font-size 10px
    color #4E5A6A //grey800

  .booking-card-icon
    margin-left 5px
    position relative
    top -1px
    cursor default

  .cc-card-icon
    margin-top 5px

.content-slim
  margin-top 1px
</style>
